// extracted by mini-css-extract-plugin
export var compactFilters = "_bt-4";
export var detailImage = "_bt-1";
export var dropdownContainer = "_bt-2";
export var imageContainer = "_bt-0";
export var selectedCard = "_bt-3";